import { useEffect, useState } from 'react';
import { ApiError } from '../lib/api';
import { registerPasswordAsker, type Bestaetigung } from '../lib/passwordConfirm';
import { Field, Modal, useToast } from './ui';

/** Dialog „Mit Passwort bestätigen“ – einmal im Rahmen der Anwendung eingehängt. */
export function PasswordConfirmHost() {
  const [request, setRequest] = useState<{ hint?: string; mitCode?: boolean; resolve: (value: Bestaetigung | null) => void } | null>(null);
  const [value, setValue] = useState('');
  const [code, setCode] = useState('');

  const { notify } = useToast();

  // Aufrufer von `api.delete` & Co. fangen den Abbruch (`cancelled`) und
  // Fehler selten selbst ab. Statt an rund 15 Stellen einzeln: still bei
  // Abbruch, sonst als Meldung – nie als ungefangene Ablehnung.
  useEffect(() => {
    const onReject = (event: PromiseRejectionEvent) => {
      if (!(event.reason instanceof ApiError)) return;
      event.preventDefault();
      if (event.reason.code !== 'cancelled') notify(event.reason.message, 'error');
    };
    window.addEventListener('unhandledrejection', onReject);
    return () => window.removeEventListener('unhandledrejection', onReject);
  }, [notify]);

  useEffect(() => {
    registerPasswordAsker(
      (hint, mitCode) =>
        new Promise((resolve) => {
          setValue('');
          setCode('');
          setRequest({ hint, mitCode, resolve });
        }),
    );
    return () => registerPasswordAsker(null);
  }, []);

  if (!request) return null;

  const ready = !!value && (!request.mitCode || code.length === 6);
  const close = (result: Bestaetigung | null) => {
    request.resolve(result);
    setRequest(null);
  };
  const submit = () => ready && close({ password: value, totp: request.mitCode ? code : undefined });

  return (
    <Modal
      title="Mit Passwort bestätigen"
      onClose={() => close(null)}
      footer={
        <>
          <button className="btn" onClick={() => close(null)}>
            Abbrechen
          </button>
          <button className="btn primary" disabled={!ready} onClick={submit}>
            Bestätigen
          </button>
        </>
      }
    >
      <form
        className="stack"
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        {request.hint && <div className="alert error">{request.hint}</div>}
        <Field label="Ihr Passwort" hint="Löschvorgänge und Änderungen an Systemrollen werden immer mit dem eigenen Passwort bestätigt.">
          <input type="password" autoFocus autoComplete="current-password" value={value} onChange={(event) => setValue(event.target.value)} />
        </Field>
        {request.mitCode && (
          <Field label="Code der Authenticator-App" hint="Sechsstellig – für das Löschen eines Superadmin-Kontos.">
            <input inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code} onChange={(event) => setCode(event.target.value.replace(/\D/g, ''))} />
          </Field>
        )}
      </form>
    </Modal>
  );
}
